<template>
  <div class="demo-split">
    <Split v-model="split1">
      <div slot="left" class="demo-split-pane">
        <TreeModel @on-select-change="onSelectChange" />
      </div>
      <div slot="right" class="demo-split-pane">
        <div class="head-view">{{ headTitle }}</div>
        <div class="btn-view">
          <!-- <div class="from-view">
            <div class="from-label">设备编号：</div>
            <Input
              placeholder="请输入设备编号"
            ></Input>
          </div>
          <Button
            style="margin-right: 10px;"
            type="primary"
            icon="ios-search"
            @click="GetUserDevicesPageV2(1)"
            >搜索</Button
          > -->
          <Button
            type="success"
            icon="md-add"
            @click="handleUser('add')"
            >{{ $t('user.index.373660-0') }}</Button
          >
        </div>
        <VTabel
          :height="height"
          :columns="columns"
          :data="dataList"
          :loading="loading"
          :total="page.total"
          :pageIndex="page.page"
          @onPageChange="onPageChange"
          @onPageSizeChange="onPageSizeChange"
          @handleRowClick="handleUser('edit', $event)"
        ></VTabel>
      </div>
    </Split>
    <add-model :show.sync="add.show" v-bind="add" @on-area="area.show = true" ref="addModel" @on-refresh="onRefresh"></add-model>
    <village-model :show.sync="area.show" @on-change="onChange"></village-model>
  </div>
</template>

<script>
import TreeModel from "../area/mods/tree.vue";
import api from "../../../../api/request.js";
import Cookies from "js-cookie";
import VTabel from "@/components/components/VTable/index.vue";
import defaultData from "./columns.js";
import AddModel from "./mods/add/index.vue"
import VillageModel from "./mods/village/index.vue"

const URL = {
  GetRoshRoomList: 'api/User/GetRoshRoomList', // 用户列表
  DeleteRoshRoom: 'api/User/DeleteRoshRoom', // 删除用户
};

export default {
  components: {
    TreeModel,
    VTabel,
    AddModel,
    VillageModel
  },
  data() {
    return {
      height: window.innerHeight - 270,
      split1: 0.2,
      query: {},
      loading: false,
      headTitle: this.$t('user.index.373660-1'),
      dataList: [],
      page: {
        page: 1,
        size: 15,
        total: 0,
      },
      add: {
        show: false,
        data: {
          type: 'add',
          row: {}
        }
      },
      area: {
        show: false
      },
      treeItem: {}, // 选中的区域
    };
  },
  computed: {
    columns() {
      return defaultData.columns(this);
    }
  },
  mounted() {
    this.getWindowInfo();
    window.addEventListener("resize", this.getWindowInfo);
    this.GetRoshRoomList(1)
  },
  methods: {
    getWindowInfo() {
      this.height = window.innerHeight - 270;
    },
    onSelectChange(item) {
      this.headTitle = item.title
      this.query = {}
      switch (item.grade) {
        case 1:
          this.query = {
            Ccode: item.Ccode
          };
          break;
        case 2:
          this.query = {
            Vcode: item.Vcode
          };
          break;
        case 3:
          this.query = {
            Scode: item.Scode
          };
          break;
        case 4:
          this.query = {
            Zcode: item.Zcode
          };
          break;
        default:
          break;
      }
      this.treeItem = { ...item }
      this.GetRoshRoomList(1)
    },
    GetRoshRoomList(page = this.page.page, size = this.page.size) {
      api({
        //这里是你自己的请求方式、url和data参数
        method: "post",
        url: URL.GetRoshRoomList,
        data: {
          ...this.query,
          pageIndex: page,
          pageSize: size
        },
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token")
        }
      }).then(res => {
        if (res.Success) {
          this.dataList = res.Data || [];
          this.page = Object.assign({}, {
            page,
            size,
            total: res.TotalCount,
          });
        }
      });
    },
    onPageChange(value) {
      this.page.page = value;
      this.GetRoshRoomList();
    },
    onPageSizeChange(value) {
      this.page.page = 1;
      this.page.size = value;
      this.GetRoshRoomList();
    },
    handleUser(type, row = {}) {
      switch (type) {
        case 'add':
          this.add.show = true;
          this.add.data = {
            type,
            row,
            tree: this.treeItem
          }
          break;
        case 'edit':
          this.add.show = true;
          this.add.data = {
            type,
            row
          }
          break;
        case 'device':
          this.$store.dispatch("setUserItem", row);
          this.$router.push({
            name: 'device'
          });
          this.$emit('on-change');
        default:
          break;
      }
    },
    onChange(item) {
      this.$refs.addModel.setVillage({...item})
    },
    // 刷新表格
    onRefresh() {
      if (this.add.data.type === 'add') {
        this.GetRoshRoomList(1)
      } else {
        this.GetRoshRoomList()
      }
    },
    // 删除
    removeClick(row) {
      api({
        //这里是你自己的请求方式、url和data参数
        method: "post",
        url: URL.DeleteRoshRoom,
        data: {...row},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token"),
        },
      }).then((res) => {
        if (res.Success) {
          this.$Message["success"]({
            background: true,
            content: res.Message,
          });
          // 清空
          this.onRefresh();
        } else {
          this.$Message["error"]({
            background: true,
            content: res.Message,
          });
        }
      });
    },
    formDateNew(date) {
      if (date) {
        let str = date.replace(/-/g, '/');
        return str.slice(0, 11);
      } else {
        return ''
      }
    },
  }
};
</script>

<style scoped>
.demo-split {
  height: 100%;
  border: 1px solid #dcdee2;
}
.demo-split-pane {
  height: 100%;
  padding: 10px 20px;
  overflow-y: auto;
}
.head-view {
  height: 40px;
  width: 100%;
  background-color: rgb(243, 245, 249);
  padding-left: 10px;
  line-height: 40px;
}
.btn-view {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 10px 0;
}
.from-view {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.from-label {
  width: 100px;
  text-align: right;
  font-weight: bold;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/useGas/views/user/index.vue